import { useTheme } from '@chakra-ui/react'
import React from 'react'
import '../../App.css'
import ButtonMore from '../buttonMore/buttonMore';
import { useAppContext } from '../../App';

export default function ImageAndParagraph({
  imgSrc,
  titleFirst='',
  titleSecond='',
  description='',
  buttonText = '',
  fontFamily = 'sansation-bold',
  fontFamilyDescription = '',
  customStyles = {},
  buttonRedirectTo = '',
  buttonCustomActions = () => null
}) {
  const theme = useTheme();
  const { isMobile } = useAppContext();
  const style = styles(theme, customStyles, isMobile);
  return (
    <div style={style.container} className={fontFamily}>
      <img src={imgSrc} style={style.img} alt="img-and-paragraph-photo"/>
      <div style={style.textContainer}>
        <h2 style={style.title1} >{titleFirst}</h2>
        <h2 style={style.title2} >{titleSecond}</h2>
        <p style={style.description} className={fontFamilyDescription}>{description}</p>
        {buttonText && <ButtonMore buttonText={buttonText} customStyles={style.buttonStyles} redirectTo={buttonRedirectTo} customActionsOnCLick={buttonCustomActions}/>}
      </div>
    </div>
  );
}
const styles = (theme, customStyles, isMobile) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: isMobile? 'column':'row',
    textAlign: isMobile? 'center':'left',
    paddingLeft: '5vw',
    paddingRight: '5vw',
    ...customStyles.container
  },
  img:{
    width: '100%',      // Hace que la imagen ocupe todo el ancho del contenedor
  height: 'auto',     // Mantiene la proporción original
  maxWidth: isMobile ? '100%' : '500px', // Opcional: limita el tamaño máximo en desktop
  display: 'block',
  margin: '0 auto',
  padding: '3vh',
    ...customStyles.img
  },
  textContainer: {
    width: isMobile? '100%':'60%',
    padding: 20,
    ...customStyles.textContainer
  },
  title1: {
    textAlign: 'left',
    fontSize: isMobile? '2rem':'3rem',
    color: theme.color.text.primary,
    ...customStyles.title1
  },
  title2: {
    textAlign: 'left',
    fontSize: isMobile? '2rem':'3rem',
    color: theme.color.text.primary,
    ...customStyles.title2
  },
  description: {
    fontSize: isMobile? '1rem':'1.5rem',
    textAlign: 'left',
    color: theme.color.text.secondary,
    ...customStyles.description
  },
  buttonStyles:{
    container:{
      width: isMobile? '60%':'30%',
      height: '5vh',
      marginTop: '2rem',
      padding: '0.5rem',
      justifyContent: 'space-around',
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.6)",
    },
    text:{
      fontSize: '1.5rem',
      width: 'auto',
    },
    arrowSvg:{
      width:'20%',
      height:'100%',
    },
    ...customStyles.buttonStyles
  }
});